import React, { useState, useEffect, useCallback } from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

const ExamTimer = ({ totalMinutes, onTimeUp, isRunning = true, label = 'Zeit', variant }) => {
  const [secondsLeft, setSecondsLeft] = useState(totalMinutes * 60);

  useEffect(() => {
    setSecondsLeft(totalMinutes * 60);
  }, [totalMinutes]);

  const handleTimeUp = useCallback(() => {
    onTimeUp?.();
  }, [onTimeUp]);

  useEffect(() => {
    if (!isRunning || secondsLeft <= 0) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleTimeUp();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, secondsLeft, handleTimeUp]);

  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const isLow = secondsLeft <= 300;
  const isCritical = secondsLeft <= 60;

  if (variant === 'pdf') {
    return (
      <div className={`exam-timer-pdf ${isCritical ? 'text-red-700 border-red-600' : ''}`}>
        {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl border font-mono text-sm font-bold ${
      isCritical ? 'bg-red-50 border-red-200 text-red-700' :
      isLow ? 'bg-orange-50 border-orange-200 text-orange-700' :
      'bg-brand-primary/10 border-brand-secondary/20 text-brand-text/80'
    }`}>
      <ClockIcon className="w-4 h-4" />
      <span className="text-[10px] uppercase tracking-widest font-sans font-medium mr-1">{label}</span>
      {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
    </div>
  );
};

export default ExamTimer;
